import { SvgIcon, SvgIconProps } from '@mui/material';
import { forwardRef } from 'react';
import Icon from './TaxCredit.svg';

const TaxCreditIcon = forwardRef<SVGSVGElement, SvgIconProps>(
  function TaxCreditIcon(props, ref) {
    return (
      <SvgIcon ref={ref} viewBox="0 0 55 55" {...props}>
        <Icon />
      </SvgIcon>
    );
  }
);

export default TaxCreditIcon;
